import React from "react";
import {
  BoldFont,
  FlexRowBetween,
  GenericDiv,
  MediumFont,
  MyHr,
  PopupForm,
} from "../Style";

const YesNoModal = ({
  yes,
  no,
  yesText = "כן",
  noText = "לא",
  body,
  title,
  yesColor = "rgba(41,59,90,0.95)",
}) => {
  return (
    <PopupForm onClick={(e) => e.stopPropagation()}>
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          justifyContent: "space-around",
        }}
      >
        <div style={{ width: "100%", marginTop: "30px" }}>
          <BoldFont
            style={{
              textAlign: "center",
              fontSize: "1.2rem",
              marginBottom: "10px",
            }}
          >
            {title}
          </BoldFont>
          <MyHr />
        </div>
        <div style={{ width: "100%", marginTop: "30px" }}>
          <MediumFont
            style={{
              textAlign: "center",
              marginBottom: "10px",
              padding: "0 20px",
            }}
          >
            {body}
          </MediumFont>
          <MyHr />
        </div>
        <div style={{ width: "100%" }}>
          <FlexRowBetween style={{ width: "90%", margin: "20px auto" }}>
            <GenericDiv
              style={{
                background: yesColor,
                padding: "9px 25px",
              }}
              onClick={() => yes()}
            >
              {yesText}
            </GenericDiv>
            <GenericDiv
              style={{
                background: "rgb(223, 223, 223)",
                color: "#3A3C3F",
                padding: "9px 25px",
              }}
              onClick={() => no(null)}
            >
              {noText}
            </GenericDiv>
          </FlexRowBetween>
        </div>
      </div>
    </PopupForm>
  );
};
export default YesNoModal;
